module.exports = __webpack_public_path__ + "static/media/GPMLogo.a5f8f2d6.png";